export default "/react/logoRocketFeed-f02102b4.png";